import { IoIosWarning } from "react-icons/io";
import "../../assets/css/idp-popup.css"
const IdpQuitPopup = ({handlePopup})=>{
    const popup = (isShow)=>{
        handlePopup(isShow)
    }
    const redirectTodestination = ()=>{
        if(!!window.location?.search?.includes('destination')) {
            window.location.href = window.location?.search?.replace("?destination=", "");
        } else {
            window.location.href = 'https://www.careers360.com'
        }
    }
    return(<>
        <div className="idp_popup">
            <div className="popup_content">
                <div className="head">
                    <IoIosWarning/> Are you sure you want to Opt out?
                </div>
                <div className="body">
                    <p>You will miss out on the following benefits:</p>
                    <ul>
                        <li>Interacting with the Top Liberal Arts and Sciences Institutes</li>
                        <li>Discounts on Application Fees and Potential Scholarships</li>
                        <li>Access to free psychometric tests, career counselling, and e-books on Liberal Arts programs in India.</li>
                    </ul>
                    <div className="button_group">
                        <button 
                        onClick={redirectTodestination}
                            className="quit_form"
                        >Yes I am sure</button>
                        <button
                        onClick={()=>popup(false)}
                         className="back_to_form btn_blue"
                        >Go Back to Form</button>
                    </div>
                </div>
            </div>
        </div>
    </>)
}

export default IdpQuitPopup 